export { default } from './scroll-to-top';
